import { RequiredTranslationsTemplate } from '.'

const sk: RequiredTranslationsTemplate = {
  meta: {
    localeName: 'Slovak',
  },
  home: {
    title: 'STIAHNUTIE PRODUKTU - ROCKRIDER XC500S',
    description:
      'Ďakujeme, že ste si zakúpili horský bicykel ROCKRIDER XC500S. Žiaľ, pri tomto bicykli sme identifikovali závadu na prednej vidlici. Táto závada sa týka len niektorých bicyklov. Prosím, vpíšte nižšie 30-miestny kód (sledovacie číslo bicykla), aby sme vedeli zistiť, či sa tento problém vzťahuje na Váš bicykel.',
    form: {
      title: 'Vyplňte, prosím, nasledujúce informácie:',
      fields: {
        serialNumber: 'Sledovacie číslo bicykla',
        serialNumberFamily: 'N° série (début)',
        firstName: 'Meno',
        lastName: 'Priezvisko',
        email: 'E-mail',
        phone: 'Telefónne číslo',
        country: 'Krajina',
        submit: 'Na overenie',
        choose: 'Vybrať...',
      },
      errors: {
        requiredField: 'Toto pole je povinné',
        unknownSerialNumber: 'Neznáme sériové číslo',
        provide6Numbers: 'Upozorňujeme, že sa vyžaduje 6 číslic',
      },
      confirmations: {
        good: {
          title: 'Vášho bicykla sa to netýka',
          p1: 'S potešením Vám oznamujeme, že závada sa netýka Vášho bicykla. Môžete si naďalej užívať jazdu.',
          p2: 'Ospravedlňujeme sa za spôsobené komplikácie.',
          p3: 'S pozdravom',
          p4: 'Tím Decathlon',
        },
        defective: {
          title: 'Je nám ľúto, ale daná závada sa týka aj vášho bicykla.',
          p1: 'Žiadame Vás, aby ste bicykel okamžite prestali používať. Navštívte, prosím, najbližšiu predajňu Decathlon a nechajte si vidlicu vymeniť.',
          p2: 'Upozorňujeme, že kvôli oprave nebudete môcť niekoľko dní používať Váš bicykel. Urobíme však všetko pre to, aby bol tento čas čo najkratší. Odporúčame Vám kontaktovať priamo servis vašej predajne Decathlon a informovať sa o odhadovanom čase opravy.',
          p3: 'Nájdite najbližšiu predajňu Decathlon',
          decathlonLocatorLink: 'https://www.decathlon.sk/content/24-nase-predajne-decathlon',
          p4: 'Nižšie nájdete dokument „Oznámenie o vrátení produktu“, ktorý si, prosím, prineste so sebou:',
          p5: 'Pre viac informácii kontaktujte naše zákaznícke centrum, ktoré je Vám k dispozícii na telefónnom čísle +421 2 221 16 888 a to od pondelka do piatka (od 9h do 18h) a tiež cez víkend (od 9h do 17h).',
        },
      },
    },
    findTheSerialNumber: {
      title: 'Ako nájsť sledovacie číslo bicykla:',
      description:
        '30-miestne číslo sa nachádza na spodnej strane rámu bicykla, v blízkosti stredového zloženia a pedálov (ukázané na obrázku nižšie).',
    },
  },
}

export default sk
